import React, { useEffect, useState } from 'react';
import SummaryApi from '../common';
import moment from 'moment';
import displayINRCurrency from '../helpers/displayCurrency';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams ,Link} from 'react-router-dom';
import { MdOutlineDoneOutline } from 'react-icons/md';
import { CiTimer, CiDeliveryTruck } from 'react-icons/ci';
import { MdEdit } from 'react-icons/md'; // Import the edit icon
import UserEditOrderStatus from './../components/UserEditOrderStatus'; // Import the edit component
import { FaRegCircleUser } from 'react-icons/fa6';
import { toast } from 'react-toastify';
import { RiRefund2Fill } from "react-icons/ri";
import { AiOutlineMenu, AiOutlineClose } from 'react-icons/ai';
import defaultImage from '../assest/DAWACO_Icon.png'; 
import ROLE from '../common/role';
import { HiXCircle } from "react-icons/hi";

const UserViewOrderDetails = () => {
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [editingOrder, setEditingOrder] = useState(null); 
    const { id, type } = useParams();  
    const user = useSelector(state => state?.user?.user);
    const location = useLocation(); 
    const navigate = useNavigate();
    const [selectedProducts, setSelectedProducts] = useState({});
    const [productQuantities, setProductQuantities] = useState({});
    const [showConfirmation, setShowConfirmation] = useState(false); 
    const [loadingAction, setLoadingAction] = useState(false);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const toggleSidebar = () => {
      setIsSidebarOpen(!isSidebarOpen);
    };
  
    useEffect(() => {
        setLoading(true);
        const loadingTimeout = setTimeout(() => {
          setLoading(false);
          navigate("/");
        }, 10000); 
    
        if (user) {
          if (user?.role !== ROLE.GENERAL) {
            navigate("/");
            setLoading(false);
          } else {
            setLoading(false);
            clearTimeout(loadingTimeout);
          }
        } 
        
    
        return () => clearTimeout(loadingTimeout);
      }, [user, navigate]);
    
    useEffect(() => {
        if (id && type) {
            fetchOrdersByUserId(id, type);  
        }
    }, [id, type]);

    const fetchOrdersByUserId = async (orderId, orderType) => {
        try {
            setLoading(true);
        
            const apiUrl = `${SummaryApi.userViewOrderDetails.url}/${orderId}/${orderType}`;
            const method = SummaryApi.userViewOrderDetails.method;
        
            const response = await fetch(apiUrl, {
                method: method,
                credentials: 'include',
            });
        
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to fetch data');
            }
        
            const responseData = await response.json();
            if (responseData.success) {
                let orders = responseData.data;
                
                if (!Array.isArray(orders)) {
                    orders = [];
                }
        
                const sortedData = orders.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                setData(sortedData || []);
            } else {
                setError(responseData.message || 'Failed to fetch data');
                setData([]);
            }
        } catch (error) {
            setError(error.message || 'Error fetching orders');
        } finally {
            setLoading(false);
        }
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'accepted':
                return 'bg-blue-900 text-white';
            case 'pending':
                return 'bg-yellow-600 text-yellow-800';
            case 'rejected':
                return 'bg-red-800 text-white';
            case 'refused':
                    return 'bg-red-800 text-white';
            case 'done':
                return 'bg-green-100 text-green-800';
            default:
                return 'bg-gray-700 text-white';
        }
    };



    const handleEditClick = (order) => {
        setEditingOrder(order);
    };

    const handleCheckboxChange = (productId) => {
        setSelectedProducts((prevSelected) => ({
            ...prevSelected,
            [productId]: !prevSelected[productId], // Toggle product selection
            
        }));

        setProductQuantities(prevQuantities => ({
            ...prevQuantities,
            [productId]: Math.max((prevQuantities[productId] || 1)) // Ensure quantity is at least 1
        }));
        
    };

    
     const hasSelectedProducts = Object.values(selectedProducts).some(value => value);


     const handleQuantityChange = (productId, increment) => {
        setProductQuantities(prevQuantities => ({
            ...prevQuantities,
            [productId]: Math.max((prevQuantities[productId] || 1) + increment, 1) // Ensure quantity is at least 1
        }));
    };


    

    

    const handleModalClose = () => {
        setShowConfirmation(false);
    };


    const handlecreateRefundRequest = async () => {
        try {
            const response = await fetch(SummaryApi.createRefundRequest.url, {
              method: SummaryApi.createRefundRequest.method,
              credentials: 'include',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                user: user,
                orderId: id,
                orderType:type,
                selectedProducts : selectedProducts,
                productQuantities : productQuantities,
              }),
            });
    
            const responseData = await response.json();
    
            if (responseData.success) {
                toast.success('تم تقديم طلب الاسترجاع بنجاح');
                setShowConfirmation(false);
                navigate('/')
            } else {
                toast.error('فشل في تقديم طلب الاسترجاع');
            }
        } catch  {
            toast.error('حدث خطأ اثناء تقديم طلب الاسترجاع');
        } 
    };


    if (loading) {
        return (
            <div className="flex justify-center items-center h-64">
                <AiOutlineLoading3Quarters className="animate-spin text-4xl text-blue-500" />
            </div>
        );
    }

    return (
        <div className='min-h-[calc(100vh-120px)] lg:flex'>
 <button onClick={toggleSidebar} className="lg:hidden fixed top-20 left-4 z-50 bg-blue-900 text-white p-2 rounded-full">
        {isSidebarOpen ? <AiOutlineClose size={18} /> : <AiOutlineMenu size={18} />}
      </button>
      {/* Sidebar */}
      <aside className={`lg:block w-full max-w-60 customShadow transition-transform duration-300 ease-in-out
                  ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} 
                  fixed lg:relative z-10 bg-white lg:bg-transparent lg:translate-x-0 h-full lg:h-auto top-18`}>

                          
  <div className='h-32 flex justify-center items-center flex-col'>
    <div className='text-5xl cursor-pointer relative flex justify-center'>
      {user?.profilePic ? (
        <img src={user?.profilePic} className='w-20 h-20 rounded-full' alt={user?.name} />
      ) : (
        <FaRegCircleUser />
      )}
    </div>
    <p className='capitalize text-lg font-semibold'>{user?.name}</p>
    <p className='text-sm'>{user?.pharmacistOrPharmacy === 'pharmacy' ? 'صيدلية' : user?.pharmacistOrPharmacy === 'pharmacist' ? 'عميل' : user?.pharmacistOrPharmacy}</p>
  </div>

  {/* Navigation */}
  <div>
    <nav className='grid p-4'>
      

      {/* معلومات الموقع */}
      <div>
      <h3 className='text-xl font-bold mb-2 text-center'>ادارة شئون الحساب</h3>
        <Link
          to='/order-history'
          
          className={`block px-2 py-1 ${location.pathname === '/order-history' ? 'bg-slate-200 font-bold' : 'hover:bg-slate-100'} text-right`}
        >
          جميع الطلبات
        </Link>
        {user?.pharmacistOrPharmacy === 'pharmacy' && (
          <>
            <Link
              to='/PaymentHistory'
              className={`block px-2 py-1 ${location.pathname === '/PaymentHistory' ? 'bg-slate-200 font-bold' : 'hover:bg-slate-100'} text-right`}
            >
              (المديونية) سجل المدفوعات
            </Link>
            <Link
              to='/userPaymentAndOrdersHistory'
              className={`block px-2 py-1 ${location.pathname === '/userPaymentAndOrdersHistory' ? 'bg-slate-200 font-bold' : 'hover:bg-slate-100'} text-right`}
            >
              سجل حسابات دواكو
            </Link>

            <Link
              to='/userRefundRequests'
              className={`block px-2 py-1 ${location.pathname === '/userRefundRequests' ? 'bg-slate-200 font-bold' : 'hover:bg-slate-100'} text-right`}
            >
              طلبات الاسترجاع
            </Link>
          </>
        )}
      </div>
    </nav>
  </div>
</aside>
<main className={`w-full h-full p-2 ${isSidebarOpen ? 'opacity-50 pointer-events-none' : 'opacity-100'}`}>
                {error ? (
                    <p className="text-red-500">{error}</p>
                ) : data.length === 0 ? (
                    <p>لا يوجد طلب حاليا</p>
                ) : (
                    data.map((item, index) => (
                        <div key={item._id || index} className="my-4">
                            <p className="font-medium text-lg">{moment(item.createdAt).format('LLL')}</p>
                            <div className="border rounded p-4">
                                <div className="flex flex-col lg:flex-row justify-between">
                                    <div className="grid gap-1">
                                        {item.productDetails?.map((product, index) => (
                                            <div key={product.productId + index} className="flex gap-3 bg-slate-100 p-2">
                                                {user?.pharmacistOrPharmacy === "pharmacy" && product?.availableForRefund > 0 && item.status!='refused'&& (
                                                    <input
                                                        type="checkbox"
                                                        checked={!!selectedProducts[product.productId]}
                                                        onChange={() => handleCheckboxChange(product.productId)}
                                                        className="mr-2"
                                                    />
                                                )}
                                                <img
                                                    src={product?.productImage?.[0] || defaultImage} 
                                                    className="w-28 h-20 bg-slate-200 object-scale-down"
                                                    alt={product?.productName}
                                                />
                                                <div>
                                                    <div className="font-medium text-lg text-ellipsis line-clamp-1">{product.productName}</div>
                                                    <div className="mt-1">
                                                        <div className="text-lg text-blue-800">
                                                            {displayINRCurrency(product.unitPrice)} : سعر المنتج الواحد
                                                        </div>
                                                        <div className="mt-1">
                                                            الكمية المطلوبة : {product.quantity}
                                                        </div>
                                                        {product?.bonus >0 &&(
                                                        <div className="mt-1">
                                                            البونص  : {product?.bonus}
                                                        </div>
                                                        )}
                                                        
                                                        {selectedProducts[product.productId] && (
                                                            
                                                            <div className="mt-1">
                                                                <div className="mt-1">
                                                            الكمية المسموح بطلب استرجاعها : {product.availableForRefund}
                                                             </div>
                                                             <div className="flex items-center">
                                                                <button
                                                                    onClick={() => handleQuantityChange(product.productId, -1)}
                                                                    className="flex items-center justify-center w-8 h-8 border border-blue-800 rounded-full hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed"
                                                                    disabled={(productQuantities[product.productId] || 1) <= 1} 
                                                                >
                                                                    <span className="text-xl">-</span>
                                                                </button>
                                                                <span className="mx-2">{productQuantities[product.productId] || 1}</span>
                                                                <button
                                                                    onClick={() => handleQuantityChange(product.productId, 1)}
                                                                    className="flex items-center justify-center w-8 h-8 border border-blue-800 rounded-full hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed"  
                                                                    disabled={(productQuantities[product.productId] || 1) >= product.availableForRefund} 
                                                                >
                                                                    <span className="text-xl">+</span>
                                                                </button>
                                                            </div>
                                                            </div>
                                                        )}
                                        
                                                        <div className="mt-1">
                                                            {displayINRCurrency(product.quantity * product.unitPrice)} : سعر الكمية المطلوبة من هذا المنتج
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <div className="font-semibold ml-auto w-fit lg:text-lg">
                                        <div className="flex items-center mb-2 gap-2">
                                            <span className="text-xl font-bold text-blue-800">
                                                {displayINRCurrency(item.totalPrice || 0)}
                                            </span>
                                            <span className="block mr-2">: المبلغ الاجمالى</span>
                                        </div>

                                        <div className="flex flex-col gap-y-6">
                                            {/* Status Section */}
                                            <div className="flex items-center">
                                                <span className="flex items-center">
                                                    {item.status === 'pending' ? (
                                                        <>
                                                            <CiTimer className="inline-block mr-2 text-yellow-500 text-2xl" />
                                                            <span className="bg-yellow-100 text-yellow-800 px-4 py-2 rounded-lg text-lg font-medium">
                                                                جاري تحضير الطلب بالمخزن
                                                            </span>
                                                        </>
                                                    ) : item.status === 'accepted' ? (
                                                        <>
                                                            <CiDeliveryTruck className="inline-block mr-2 text-blue-900 text-2xl" />
                                                            <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-lg text-lg font-medium">
                                                                تم تحضير الطلب وجاهز للتوصيل
                                                            </span>
                                                            <MdEdit 
                                                                className="ml-2 text-blue-600 text-xl cursor-pointer" 
                                                                onClick={() => handleEditClick(item)} 
                                                            />
                                                        </>
                                                    ) : item.status === 'done' ? (
                                                        item.type==='order'?
                                                        <>
                                                            <MdOutlineDoneOutline className="inline-block mr-2 text-green-500 text-2xl" />
                                                            <span className="bg-green-100 text-green-800 px-4 py-2 rounded-lg text-lg font-medium">
                                                                تم ايصال الطلب بنجاح
                                                            </span>
                                                        </>
                                                        :
                                                        <>
                                                        <RiRefund2Fill className="inline-block mr-2 text-green-500 text-2xl" />
                                                        <span className="bg-green-100 text-green-800 px-4 py-2 rounded-lg text-lg font-medium">
                                                           تم قبول طلب الاسترجاع
                                                        </span>
                                                        
                                                      </>

                                                        
                                                    ): 
                                                    item.status === 'refused' ? (
                                                        <>
                                                            <HiXCircle className="inline-block mr-2 text-red-500 text-3xl" />
                                                            <span className="bg-red-100 text-red-800 px-4 py-2 rounded-lg text-lg font-medium">
                                                                تم رفض الطلب
                                                            </span>
                                                        </>
                                                    ):    
                                                    (
                                                        <span className={`px-4 py-2 rounded-lg text-lg font-medium ${getStatusColor(item.status)}`}>
                                                            {item.status}
                                                        </span>
                                                    )}
                                                </span>
                                            </div>

                                            {item.type==='order'&&
                                           <div className="mb-2 ml-20">
                                                
                                             {item.orderSalesManName &&   <p className="font-medium text-lg">
                                                    <span className="font-semibold text-gray-700"></span>  ({item.orderSalesManName}): تم الطلب بواسطة مندوب المبيعات
                                                </p>}
                                                {item.orderSalesManName==='' &&   <p className="font-medium text-lg">
                                                    <span className="font-semibold text-gray-700"></span> تم الطلب بواسطة الصيدلية 
                                                </p>}

                                                {item.refundAdminId &&   <p className="font-medium text-lg">
                                                    <span className="font-semibold text-gray-700"></span>   تم الرفض بواسطة الادمن  
                                                </p>}
                                                {item.editedAdminId &&   <p className="font-medium text-lg">
                                                    <span className="font-semibold text-gray-700"></span>   تم التعديل بواسطة الادمن  
                                                </p>}

                                                <p className="font-medium text-lg">
                                                    <span className="font-semibold text-gray-700">كود الطلب:</span> #{item.orderCode}
                                                </p>

                                                {item.clientNotes !=="" &&
                                                    <p className="font-medium text-lg">
                                                        <span className="font-semibold text-red-700">ملحوظات : </span> {item.clientNotes}
                                                    </p>
                                                }
                                            </div>
                                            
                                            
                                            } 

                                           {item.type==='refund'&&
                                           <div className="mb-2 ml-20">
                                                <p className="font-medium text-lg">
                                                    <span className="font-semibold text-gray-700">كود المرتجع:</span> #{item.orderCode}
                                                </p>

                                                <p className="font-medium text-lg">
                                                    <span className="font-semibold text-gray-700">مرتجع من الطلب  </span> #{item.refundFromOrderNumber}
                                                </p>
                                                {item.refundSalesManId===""&&item.refundAdminId===""&&
                                                <p className="font-medium text-lg">
                                                    <span className="font-semibold text-gray-700">تم بواسطة الصيدلية </span> 
                                                </p>}
                                                {item.refundSalesManId!==""&&
                                                <p className="font-medium text-lg">
                                                    <span className="font-semibold text-gray-700">تم بواسطة مندوب المبيعات </span> ({item.refundSalesManName})
                                                </p>}
                                                {item.refundSalesManId===""&&item.refundAdminId!==""&&
                                                <p className="font-medium text-lg">
                                                    <span className="font-semibold text-gray-700">تم بواسطة الادمن </span> 
                                                </p>}
                                            </div>} 


                                            {/* Order Details Section */}
                                            <div className="mb-4 p-4 border border-gray-200 rounded-lg bg-white shadow-md text-right">
                                                <h2 className="text-xl font-semibold mb-4 text-blue-900 "> : معلومات مندوب المبيعات  </h2>
                                                <div className="mb-2">
                                                    <p className="font-medium text-lg">
                                                        <span className="font-semibold text-gray-500"> الاسم : </span> {item.salesManName ? item.salesManName : 'لم يتم تكليف مندوب مبيعات بعد بهذا الطلب'}
                                                    </p>
                                                </div>
                                                <div className="mb-2">
                                                    <p className="font-medium text-lg">
                                                        <span className="font-semibold text-gray-500"> البريد الالكتروني  : </span> {item.salesManEmail ? item.salesManEmail : 'لم يتم تكليف مندوب مبيعات بعد بهذا الطلب'}
                                                    </p>
                                                </div>
                                                <div className="mb-2">
                                                    <p className="font-medium text-lg">
                                                        <span className="font-semibold text-gray-500"> رقم الهاتف المحمول   : </span> {item.salesManMobileNumber ? item.salesManMobileNumber : 'لم يتم تكليف مندوب مبيعات بعد بهذا الطلب'}
                                                    </p>
                                                </div>
                                                <div className="mb-2">
                                                    <p className="font-medium text-lg">
                                                        <span className="font-semibold text-gray-500">اسم الشركة    : </span> {type==='Medicine'?'شركة دواكو':'شركة مستحضرات التجميل'}
                                                    </p>
                                                </div>
                                                {user?.pharmacistOrPharmacy==='pharmacist' &&
                                                <div className="mb-2">
                                                    <p className="font-medium text-lg">
                                                        <span className="font-semibold text-gray-500">العنوان : </span> {item.shippingAddress || 'لم يتم تحديد عنوان الشحن'}
                                                    </p>
                                                </div>
                                                }
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                           {/* Button Section */}
                            {user?.pharmacistOrPharmacy === "pharmacy" &&item.status!='refused'&& ( // Check if user is a pharmacy
                                <div className="flex justify-start mt-4">
                                    <button 
                                        className={`bg-red-500 text-white px-4 py-2 rounded-lg shadow-lg ${!hasSelectedProducts ? 'opacity-50 cursor-not-allowed' : ''}`}
                                        disabled={!hasSelectedProducts} // Disable button if no product is selected
                                        onClick={() => setShowConfirmation(true)}
                                    >
                                        تقديم طلب الاسترجاع
                                    </button>
                                   

                                </div>
                            )}
                                        <div className="mb-2 text-right">
                                         <p className="font-medium text-lg">
                                        <span className="font-semibold text-red-700"> ملحوظة هامة : يرجى العلم بأن المشرف له الحق في قبول/رفض كل أو جزء من طلب الاسترجاع </span> 
                                         </p>
                                        </div>
                            
                            
                        </div>
                        
                    ))
                    
                )}
                
                
                {editingOrder && (
                    <UserEditOrderStatus 
                        order={editingOrder}
                        onClose={() => setEditingOrder(null)}
                        fetchData={fetchOrdersByUserId} 
                    />
                )}


{/* Confirmation Modal */}
{showConfirmation && (
    <>
        {/* Backdrop */}
        <div className="fixed inset-0 flex items-center justify-center z-50">
        
        {/* Modal */}
        <div className="absolute inset-0 bg-black bg-opacity-10"></div>
        <div className="bg-white p-6 rounded shadow-lg relative"> 
            {/* Centered title */}
            <h3 className="text-lg font-semibold mb-4 text-center">تأكيد الطلب</h3>
            
            {/* Conditional rendering of confirmation message */}
            {!loadingAction && (
                <p className='text-lg mb-4 text-center'>
                    هل أنت متأكد أنك تريد تقديم طلب الاسترجاع؟
                </p>
                
            )}
            
            {/* Buttons or loading spinner */}
            <div className="mt-4 flex justify-center gap-4">
                {loadingAction ? (
                    <div className="flex items-center justify-center">
                        {/* Loading Icon from react-icons */}
                        <AiOutlineLoading3Quarters className="animate-spin text-4xl text-blue-500" />
                    </div>
                ) : (
                    <>
                        <button 
                            className='bg-red-500 text-white px-4 py-2 rounded' 
                            onClick={async () => {
                                setLoadingAction(true); 
                                await handlecreateRefundRequest();
                                setLoadingAction(false); 
                            }}
                        >
                            نعم
                        </button>
                        <button className='bg-gray-300 px-4 py-2 rounded' onClick={handleModalClose}>
                            لا
                        </button>
                    </>
                )}
            </div>
        </div>
    </div>
    </>
)}






            </main>
           
        </div>
    );
};

export default UserViewOrderDetails;
